import React from "react";

function CategoriaProd(props){
    return (
        <h5>{props.name}</h5>
    );
}
export default CategoriaProd;